import {computed, defineComponent} from 'vue';

export default defineComponent({
    name: 'AegTestPaymentData',
    props: {},
    setup(props) {
        const showTestPaymentData: string = import.meta.env.VITE_SHOW_TEST_PAYMENT_DATA;

        const isVisible = computed((): boolean => { 
            return showTestPaymentData === 'true';
        });
        
        return {
            isVisible,
        };
    }
})
